/**
 * Created by ilja on 9/5/2017.
 */
module Arkadium.Game {
    import DependenciesContainer = Factive.Core.DependenciesContainer;
    import GameBase = Factive.Game.GameBase;

    export class GameAutoTestingManager {

        private _eventBus: Factive.Core.EventBus;
        private _game: GameBase;
        private _arenaHelper: Arkadium.Game.ArenaHelper;

        private _playActionHandler:Function;


        constructor(game: GameBase, dc:DependenciesContainer){
            this._game = game;
            this._eventBus = dc.get("EventBus");
            this._arenaHelper = dc.get("ArenaHelper");
        }

        public init(playActionHandler)
        {
            this._playActionHandler = playActionHandler;
            this._arenaHelper.testActionCallback = this.testArenaCallback.bind(this);
            this._arenaHelper.initTestingEnvironment();
        }

        private testArenaCallback(action: string)
        {
            //console.log("Testing action = "+action)
            switch (action)
            {
                case "game_end":
                {

                    break;
                }
                case "play_game":
                {
                    if (this._playActionHandler)
                    {
                        this._playActionHandler();
                    }
                    break;
                }
                case "quit_game":
                {
                    this._arenaHelper.sendGameEnd(1);
                    break;
                }
                case "draw_border":
                {
                    var width = this._game.renderer.view.width;
                    var height = this._game.renderer.view.height;
                    var graphics = new PIXI.Graphics();
                    graphics.beginFill(0xff0000);
                    graphics.lineStyle(10, 0x00ff00, 1);
                    graphics.moveTo(0,0);
                    graphics.lineTo(width,0);
                    graphics.lineTo(width,height);
                    graphics.lineTo(0,height);
                    graphics.lineTo(0,0);
                    graphics.endFill();
                    // graphics.x = - width*.5;
                    // graphics.y = - height*.5;
                    this._game._stage.addChild(graphics);
                    break;
                }
                default:
                {
                    this._arenaHelper.handleCustomEvent(action, null);
                }
            }
        }

    }
}



// WEBPACK FOOTER //
// src/typescript/Core/Arena/GameAutoTestingManager.ts